import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AddVessel() {
  const navigate = useNavigate();
  useEffect(() => { navigate("/vessels", { replace: true }); }, [navigate]);
  return null;
}
